import {IJackpotBetsInfoViewModel} from "./models/jackpot-bets-info.view-model.interface";

export enum JackpotBetsOptStatusType {
    NotAvailable = -99,
    Unknown = 0,
    OptIn = 1,
    OptOut = 2,
}

export interface IJackpotBetParticipationData {
    optInStatus: JackpotBetsOptStatusType;
    participationFee: number;
}

export interface IJackpotBetsService {
    readonly isEnabled: boolean;
    readonly participationFee: number;
    readonly jackpotsInfo: IJackpotBetsInfoViewModel; 
    readonly optInStatus: JackpotBetsOptStatusType;   
    getOptInStatus(): Promise<JackpotBetsOptStatusType>;
    getParticipationData(): Promise<IJackpotBetParticipationData>;
    toggleJackpotBet(): Promise<void>;
    requestOptInDialog(): Promise<void>;
    sendJackpotBetEvent(action: string, label?: string, value?: any): void;
}